export default __webpack_public_path__ + "static/media/man-sitting-on-coins.0632ac9d.svg";